.labelLg {
  font: var(--label-lg-font);
  letter-spacing: var(--label-lg-letter-spacing);
}

.labelMd {
  font: var(--label-md-font);
  letter-spacing: var(--label-md-letter-spacing);
}

.labelSm {
  font: var(--label-sm-font);
  letter-spacing: var(--label-sm-letter-spacing);
}

.primary {
  color: var(--content-primary);
}

.secondary {
  color: var(--content-secondary);
}

.tertiary {
  color: var(--content-secondary);
}

.light {
  color: var(--content-inverse);
}

.disabled {
  color: var(--content-disabled);
}

.accent {
  color: var(--content-accent);
}

.success {
  color: var(--content-status-success);
}

.warning {
  color: var(--content-status-warning);
}

.danger {
  color: var(--content-status-error);
}

.plus {
  color: var(--brand-colors-plus-brand);
}
